import { render, staticRenderFns } from "./SuccessSubmission.vue?vue&type=template&id=22c61aca&scoped=true&"
import script from "./SuccessSubmission.vue?vue&type=script&lang=js&"
export * from "./SuccessSubmission.vue?vue&type=script&lang=js&"
import style0 from "./SuccessSubmission.vue?vue&type=style&index=0&id=22c61aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c61aca",
  null
  
)

export default component.exports